// import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import {Loading, Message} from 'element-ui'
import store1 from '../CancelToken'

const CancelToken = axios.CancelToken
let cancel;
let domain  = document.domain
//let domain  = 'www.bilai88.com'
let baseurl = '';
if(domain == 'localhost'||'47.244.134.96'){
  baseurl  = 'http://api.2paiming.com/'
}else{
//  domain.replace('www','apo')
    if(domain.indexOf('www')!=-1){
      baseurl = 'http://'+domain.replace('www','api')
    }else{
      baseurl = 'http://api.'+domain
    }
}

// 配置请求头
const instance = axios.create({
  baseURL: baseurl+'/api', // 'http://192.168.72.128:8001', // ,'http://beibei.jakejie.com'
  // timeout: '10000',
  withCredentials: true,
  cache: false,
})
// 配置请求头
const instance1 = axios.create({
  baseURL: 'http://www.seo6.cn/ajax.ashx', // 'http://192.168.72.128:8001', // ,'http://beibei.jakejie.com'
  // timeout: '10000',
  withCredentials: true,
  cache: false,
})

const instance2 = axios.create({
    baseURL: baseurl+'/api', // 'http://192.168.72.128:8001', // ,'http://beibei.jakejie.com'
    // timeout: '10000',
    withCredentials: true,
    cache: false,
})
// 这里声明一个全局变量loading，来统一控制请求时的loading效果
let loading

// request拦截器，在请求或响应被then或catch处理前拦截他们
instance.interceptors.request.use(config => {

  if (config.method === 'get') {

    if (typeof config.params.needLoading === 'boolean') {

    } else {

      loading = Loading.service({
        fullscreen: true,
        lock: true,
        text: '正在加载，请稍等...',
        spinner: 'el-icon-loading'
      })
    }
  } else {

    if (config.data && typeof config.data.needLoading === 'boolean') {
      // console.log(1)
    } else {
      loading = Loading.service({
        fullscreen: true,
        lock: true,
        text: '正在加载，请稍等...',
        spinner: 'el-icon-loading'
      })
    }
  }

  // 让每个请求携带token，token的key值根据情况自行定义
  // if(localStorage.getItem('aipaimingToken')){
  //   config.data = Object.assign({token: localStorage.getItem('aipaimingToken')})
  // }

  // 请求参数序列化
  // 'login' 其实就是 this.GET_CODE_URL
 //
  if (config.url == 'http://2paiming.com/api/user/card_auth') {
    config.headers['Content-Type'] = 'multipart/form-data'

  } else{
    if(!config.headers['Content-Type']){
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }

  }
  //  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  if(localStorage.getItem('aipaimingToken')){
    Object.assign(config.headers, { 'token': localStorage.getItem('aipaimingToken')});
  }
  if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
    config.data = qs.stringify(config.data)
  }

  config.cancelToken = new CancelToken((cancel) => {
    store1._axiosPromiseCancel.push(cancel)
  })

  return config
}, error => {
  if (loading) {
    loading.close()
  }
  // 对错误请求进行处理，并弹出错误信息
  Message({
    showClose: true,
    message: error.message,
    type: 'error'
  })

  return Promise.reject(error)
})

// response拦截，对请求结果做一些处理
instance.interceptors.response.use(response => {
  // 这里根据从后端拿到的数据进行一些处理，比如对不同的responseCode做不同的操作
  // return Promise.resolve(response)
  if (loading) {
    loading.close()
  }
  let p = new Promise((resolve, reject) => {
    resolve(response)
  })

  return p
}, error => {
  if (loading) {
    loading.close()
  }
  if(axios.isCancel(error)){
    return new Promise((resolve, reject) => {

    })
  }else{

    if(error.response.data.code == 401){

      Message({
        message: '请先登录',
        type: 'error',
        duration: 3 * 1000
      })
        localStorage.removeItem('loginUsername')
        localStorage.removeItem('aipaimingToken')
    }else{
      Message({
        message: error.message,
        type: 'error',
        duration: 3 * 1000
      })
    }
   // return Promise.reject(error)
  }

})

// 封装并导出get方法和post方法
export default {
  getInstance(){
    return instance;
  },
  get (url, params={}) {
    let para = Object.assign(params, {t: new Date().getTime()})
    // let paramsStr = '?'
    // for (let key in params) {
    //   if(params[key] instanceof Array) {
    //     paramsStr += `${key}=[${params[key]}]&`
    //   }else{
    //     paramsStr += `${key}=${params[key]}&`
    //   }
    // }
    // return instance.get(`${url}${paramsStr}t=${new Date().getTime()}`)
    return instance.get(url, {
      params: para
    })
  },
  post (url, params,config) {

    return instance.post(url, params,config)
  },
  formSubmit(url, params, config){
    return instance.post(url, params, config)
  },
  resourceGet(params) {
    let paramsStr = '?'
    for (let key in params) {
      paramsStr += `${key}=${params[key]}&`
    }
    return instance1.get(`http://www.seo6.cn/ajax.ashx${paramsStr}t=${new Date().getTime()}`)
  },
  instance1,
  instance,
  instance2,
  baseurl
}



// WEBPACK FOOTER //
// ./src/service/fetch.js